module.exports = __webpack_public_path__ + "img/auth3.6e318616.png";